"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const isAbsent = value => value == null;

var _default = isAbsent;
exports.default = _default;